import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class BonusIntro extends PIXI.Container implements StageLayer {
    private _spine: PIXI.spine.Spine | null;
    //private _congratsTxt: PIXI.Text;
    private _youWonTxt: PIXI.Text;
    private _freespinsNameText: PIXI.Text;
    private _spinsWonNr: PIXI.BitmapText;
    private _spinsNo: number;
    private _FSname: string;
    private actualBingeIntro: boolean = false;


    constructor() {
        super();
        this.name = "FSIntroView";
        this.init();
    }

    public hideBonusIntro(): gsap.core.Timeline {
        const hideIntroTL: gsap.core.Timeline = gsap.timeline();
        const outTime: number = SpineGSAPWrapper.animationTimeDuration(this._spine!, `${this._FSname} Intro OUT`);
        hideIntroTL.add(SpineGSAPWrapper.createTimelineForAnimation(this._spine!, 0, `${this._FSname} Intro OUT`, false));
        hideIntroTL.to([this, this._spinsWonNr, /*this._spine*/, /*this._congratsTxt*/, this._youWonTxt, this._freespinsNameText], {
            duration: outTime,
            alpha: 0
        }, "<");

        hideIntroTL.add(XwaysHoarder2.darkOverlay.hideOverlay(), "<");
        hideIntroTL.add(() => {
            this.visible = false;
            this._freespinsNameText.visible = false;
            this._spine!.visible = false;
            this._spinsWonNr.visible = false;
            this._spinsWonNr.text = "1";
            //  this._congratsTxt.visible = false;
            this._youWonTxt.visible = false;
            this._spine?.destroy();
            this._spine = null;
            XwaysHoarder2.keypadPlugin.setZeroBetSpinCounter(this._spinsNo);
        }, ">");
        return hideIntroTL;
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }


        /* if (!NolimitApplication.isLandscape) {
             if (this._congratsTxt.width > 700) {
                 this._congratsTxt.scale.set(700 / this._congratsTxt.width, 700 / this._congratsTxt.width);
             } else {
                 this._congratsTxt.scale.set(1, 1);
             }
         } else {
             this._congratsTxt.scale.set(1, 1);
         }*/

    }

    public showBonusIntro(actualBinge: boolean): gsap.core.Timeline {
        this.actualBingeIntro = actualBinge;
        this.addIntroSpine();
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {

            this._spinsWonNr.visible = true;
            this._freespinsNameText.visible = true;
            this._youWonTxt.visible = true;
            // this._congratsTxt.visible = true;
            XwaysHoarder2.darkOverlay.addOverlay();
            this._spine!.visible = true;
            this.visible = true;
            this.alpha = 1;
            let fsName: string = XwaysHoarder2.model.data.nextMode === "FREESPIN" ? "RAID SPINS" : "PLUNDER SPINS";
            if (XwaysHoarder2.model.data.nextFSLevel >= 4 && actualBinge) {
                fsName = "BINGE SPINS";
                //XwaysHoarder2.keypadPlugin.setZeroBetSpinCounter(XwaysHoarder2.model.data.freespinsLeft);
                    SlotGame.keypadPlugin.setZeroBetSpinCounter(XwaysHoarder2.model.data.freespinsLeft);
            }
            this._freespinsNameText.text = fsName;
            this._freespinsNameText.position.set(360, 480);
            this._spinsWonNr.text = "1";
            this._spinsWonNr.position.set(352, 350);
            XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.BONUS_INTRO});
            this.onResize();
        }, 0);
        tl.to(this._spine, {duration: 0.05, alpha: 1}, 0);
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this._spine!, 0, `${this._FSname} Intro IN`, false));
        tl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BONUS_INTRO_START);
        }, "<");
        tl.to(this._spinsWonNr, {duration: 0.05, alpha: 1});
        tl.add(this.countupSpins());
        tl.to([this._freespinsNameText, /*this._congratsTxt*/, this._youWonTxt], {
            duration: 0.3,
            alpha: 1
        })

        tl.to(this, {duration: 0.2});

        return tl;
    }

    private init(): void {


        /* this._congratsTxt = new PIXI.Text(XwaysHoarder2.apiPlugin.translations.translate("CONGRATULATIONS!"));
         this._congratsTxt.style = new PIXI.TextStyle(XwaysHoarder2Statics.TRANSITION_HEADING_STYLE);
         this.addChild(this._congratsTxt);
         this._congratsTxt.position.set(360, 150);
         this._congratsTxt.name = "congratulations";
         this._congratsTxt.alpha = 0;
         this._congratsTxt.anchor.set(0.5, 0.5);*/
        this.position.set(0, 40);

        this._youWonTxt = new PIXI.Text(XwaysHoarder2.apiPlugin.translations.translate("YOU WON"), new PIXI.TextStyle(XwaysHoarder2Statics.INTRO_TRANSITION_CONTENT_STYLE));
        this._youWonTxt.name = "you Won";
        this._youWonTxt.alpha = 0;
        this._youWonTxt.anchor.set(0.5, 0.5);
        this._youWonTxt.position.set(360, 285);
        this.addChild(this._youWonTxt);


        this._freespinsNameText = new PIXI.Text("", new PIXI.TextStyle(XwaysHoarder2Statics.INTRO_TRANSITION_CONTENT_STYLE));
        this._freespinsNameText.visible = false;
        this._freespinsNameText.alpha = 0;
        this._freespinsNameText.name = "freespin Name text";
        this._freespinsNameText.anchor.set(0.5, 0.5);
        this.addChild(this._freespinsNameText);

        this._spinsWonNr = new PIXI.BitmapText("1", {
            fontName: XwaysHoarder2GameAssets.FS_INTRO_SPINS_COUNTUP,
            fontSize: 45,
            letterSpacing: 25,
            align: "center"
        });
        this._spinsWonNr.visible = false;
        this._spinsWonNr.alpha = 0;
        this._spinsWonNr.name = "spins won no.";
        this.addChild(this._spinsWonNr);

        this.visible = false;
        this.onResize();
    }

    private addIntroSpine(): void {
        let spineName: string = XwaysHoarder2.model.data.nextMode === GameMode.FREESPIN ? XwaysHoarder2GameAssets.FS_INTRO_OUTRO : XwaysHoarder2GameAssets.SFS_INTRO_OUTRO
        if (XwaysHoarder2.model.data.nextFSLevel >= 4 && this.actualBingeIntro) {
            spineName = XwaysHoarder2GameAssets.BINGE_INTRO_OUTRO;
        }
        this._spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(spineName));
        this._spine.position.set(360, 270);
        this._spine.name = "introSpine";
        this._spine.alpha = 0;
        this._FSname = XwaysHoarder2.model.data.nextMode === GameMode.FREESPIN ? "FS" : "SFS";
        if (XwaysHoarder2.model.data.nextFSLevel >= 4 && this.actualBingeIntro) {
            this._FSname = "Binge";
        }
        this.addChild(this._spine, this._youWonTxt, this._spinsWonNr, this._freespinsNameText);
    }

    private countupSpins(): gsap.core.Timeline {
        const countupTl: gsap.core.Timeline = gsap.timeline();
        this.freespinWonNumber();
        for (let i: number = 2; i <= this._spinsNo; i++) {
            const oneUpTl: gsap.core.Timeline = gsap.timeline();
            oneUpTl.add(() => {
                this._spinsWonNr.text = i.toString();
                this._spinsWonNr.pivot.x = this._spinsWonNr.width * 0.5;
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BONUS_INTRO_COUNTUP);
            });
            oneUpTl.to(this, {duration: 0.05});
            countupTl.add(oneUpTl);
        }
        countupTl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BONUS_INTRO_COUNTUP);
        }, 0);
        return countupTl;
    }

    private freespinWonNumber(): void {
        let scatterCount: number = 0;
        [1, 2, 3, 4, 5].forEach((reelId: number) => {
            [0, 1, 2].forEach((symId: number) => {
                if (XwaysHoarder2.model.data.reels[reelId][symId] === "SC" || XwaysHoarder2.model.data.reels[reelId][symId] === "SSC") {
                    scatterCount++;
                }
            });
        });
        if (scatterCount === 3) {
            this._spinsNo = 7;
        } else if (scatterCount === 4) {
            this._spinsNo = 10;
        } else if (scatterCount === 5) {
            this._spinsNo = 13;
        }
        if (XwaysHoarder2.model.data.nextFSLevel >= 4) {
            if(this.actualBingeIntro){
                this._spinsNo = XwaysHoarder2.model.data.freespinsLeft;
            }
        }
    }
}